<script setup lang="ts">
import { ref, onMounted, getCurrentInstance } from "vue";
import { Globals } from "@/Globals";
import { getValue, getKZValueDisplay } from "@/DataHelper";
// import CalcHelper from "@/components/CalcHelper";
import { showSnackbar } from "@/UIHelper";
import AUApi from "@/api";
import { calcFunctionNew } from "@/CalcHelperStatic";
import { globalsBegriffMemo, globalsKennung } from "@/local";

const emit = defineEmits(["back", "calculated", "onCalculate"]);

interface Props {
  modell?: string;
  icon?: string;
  color?: string;
  block?: string;
  size?: string;
  text?: string;
  height?: string;
  width?: string;
  modellAic?: number;
  showDisabled?: boolean;
  bewAic?: boolean;
  vecStamm?: number[];
  // vectorSelect?: QueryDataRow[];
  useVecStamm?: boolean;
  disabled?: boolean;
  showResult?: boolean;
  varUebergabe?: VarUebergabe[];
  zeitbereich?: APIZeitbereich;
  varName2?: string;
  varZeitart?: string;
  nodeRequest?: string;
}
const props = defineProps<Props>();

let varUebergabe = ref<VarUebergabe[]>([]);
let showDef = ref<boolean>(false);

const dialog = ref<boolean>(false);
const queryAIC = undefined as number | undefined;
const data: DataColumn[] = [];
let columns: DataColumn[] = [];
const isApiBusy = ref<boolean>(false);
// aus CalcHelper!- muss wieder dort hin..
let showLoading = ref<boolean>(false);
let begriffModell = ref<ALLModell | null>(null);
let aic = ref<number>(0);
let iconAmpel = ref<string>("");
let calcResult = ref<string>("");
const text = ref<string>("");

onMounted(() => {
  if (props.modell) {
    begriffModell.value = globalsKennung(Globals.Begriff, props.modell);
  }
  // ist der aktuelle user Def Berechtigt, darf er Debug und Abbruch setzen!
  if (AUApi.Current.user?.rechte === "Def") {
    showDef.value = true;
  }
  if (props.text) {
    text.value = props.text;
  }
  if (props.modellAic) {
    aic.value = props.modellAic;
  }
  // wenn es eine Abgfrage OHNE Parameter MDialog gibt
  // dann geht es um eine Anzeige auf dem Button - zB Ampeln
  if (
    begriffModell.value !== null &&
    begriffModell.value?.abfrage !== undefined &&
    !begriffModell.value?.MDialog
  ) {
    const abfrageAic = begriffModell.value.abfrage;
    // console.log("calcButton asking for " + abfrageAic + ' zb: ' + JSON.stringify(zeitbereich));
    if (abfrageAic) {
      if (props.useVecStamm && props.vecStamm && props.vecStamm.length === 0) {
        showSnackbar({
          text: "ACHTUNG: es muss mind. 1 Mitarbeiter ausgewählt sein! Die Berechnung wird abgebrochen",
          color: "error",
        });
        return;

        // $emit("back");
      }
      AUApi.Current.getQuery(
        abfrageAic,
        (data: any) => dataLoaded(data),
        queryAIC,
        props.zeitbereich,
        0,
        false,
        false,
        "",
        0,
        props.vecStamm,
      );
    }
  }
});
function dataLoaded(data: any) {
  if (data.data.error !== undefined) {
    AUApi.Current.onfail(data.data.error);
    console.log(data.data.error);
    alert("ACHTUNG: " + data.data.error);
    emit("back");
    return;
  }

  columns = data.data.columns;
  data = data.data.data;
  if (data.length > 0) {
    const row = data[0];
    const ampelIcon = getKZValueDisplay(row, "icon", columns);

    if (ampelIcon) {
      iconAmpel = ampelIcon;
    }
  }
}
async function onCalcFunction() {
  emit("onCalculate");
  if (props.disabled) {
    showSnackbar({
      text: "Berechnung nicht erlaubt!",
      color: "error",
    });
    emit("back");
    return;
  } else if (
    props.useVecStamm &&
    props.vecStamm &&
    props.vecStamm.length === 0
  ) {
    showSnackbar({
      text: "ACHTUNG: es muss mind. 1 Mitarbeiter ausgewählt sein! Die Berechnung wird abgebrochen",
      color: "error",
    });
    emit("back");
    return;
  } else {
    if (props.modellAic) {
      aic.value = props.modellAic;
    }

    const modell = props.modell ?? "";
    let fromBew = false;
    if (props.bewAic) {
      fromBew = true;
    }
    varUebergabe.value = [];
    if (props.varUebergabe && props.varUebergabe.length > 0) {
      varUebergabe.value = props.varUebergabe;
    }
    if (props.varName2) {
      varUebergabe.value.push({
        var: props.varName2,
        wert: props.varZeitart,
        art: 1,
        user: AUApi.Current.user!.user,
        perm: false,
      });
    }
    if (props.nodeRequest) {
      showLoading.value = true;
      await AUApi.Current.postCalc(
        varUebergabe.value,
        [],
        0,
        aic.value,
        props.zeitbereich,
        0,
        0,
        "",
        onNodeFunctionFinished,
        undefined,
        [],
        0,
        [],
        props.nodeRequest,
      );
    } else {
      await calcFunctionNew(
        modell,
        aic.value,
        false,
        onCalculatedFinished,
        props.zeitbereich,
        varUebergabe.value ?? [],
        [],
        "",
        props.vecStamm,
        (loading) => (
          console.log("Loading: " + loading),
          (showLoading.value = loading)
        ),
        false,
        false,
        fromBew,
      );
    }
  }
}
function onNodeFunctionFinished(data: any) {
  if (data?.data?.msgType === "Error") {
    showSnackbar({
      text: data.data.info,
      color: "error",
    });
  }
  if (data.data.ergebnis) {
    showSnackbar({
      text: data.data.ergebnis,
      color: "success",
    });
  }
  showLoading.value = false;
  emit("calculated", data);
}
function onCalculatedFinished(data: any) {
  emit("calculated", data);
  // Abschluss der Berechnung: Loading in jedem Fall sauber zuruecksetzen.
  showLoading.value = false;
}

function currentColor() {
  if (props.disabled || isApiBusy.value) {
    return "#aaa";
  }
  return props.color;
}
</script>
<template>
  <div class="d-flex justify-center align-center flex-column h-100">
    <v-btn
      v-if="begriffModell || props.nodeRequest"
      ref="calcBtn"
      :color="currentColor()"
      block
      class="calcButton"
      :prepend-icon="props.icon"
      :disabled="showDisabled"
      @click="onCalcFunction()"
      eager
      variant="flat"
      rounded="0"
    >
      <slot v-if="!showLoading && text">{{ text }}</slot>
      &nbsp;
      <!-- <span v-if="calcResult && showResult">{{ calcResult }}</span> -->
      <v-progress-circular
        :width="3"
        :indeterminate="true"
        v-if="showLoading"
      ></v-progress-circular>
      <v-img v-if="iconAmpel">&nbsp;{{ iconAmpel }}</v-img>
    </v-btn>
  </div>
</template>
<style scoped>
.v-btn--icon.v-size--small .v-icon,
.v-btn--fab.v-size--small .v-icon {
  height: 40px;
  width: 40px;
}
.calcButton {
  text-align: left;
  white-space: normal;
  padding: 8px;
  /* margin-top: 5px; */
  justify-content: left;
}
.calcResult {
  font-size: x-small;
  color: white;
  text-transform: none;
  white-space: normal;
  margin: 10px;
}
.grey--text {
  color: white !important;
  caret-color: white !important;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
</style>
